import { AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Gallery } from 'src/app/models/gallery.model';
import { ImageService } from 'src/app/services/image/image.service';
import { ShowGalleryService } from 'src/app/services/showGallery/show-gallery.service';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit,AfterViewChecked,OnDestroy {
  showList:boolean=true;
  images:any[];
  filterImage:Gallery[]=[];
  sub:Subscription[]=[];
  constructor(private showService:ShowGalleryService,
    private imgService:ImageService,
    private cdRef:ChangeDetectorRef,
    private router:Router) { 
  }

  ngOnInit(): void {
    this.imgService.getImgDetailList();
    this.sub[0]= this.imgService.imgDetailList.snapshotChanges().subscribe(
      list=>{
      this.images=  list.map(item=>{  return {
        $key:this.convertingUrl(item.payload.val().caption),
        ... item.payload.val()
      }});
      this.imgService.setCategory(this.images);
      this.filterImage=this.imgService.setFilter();
      this.splitUrl();
      }
      );
      this.sub[1]=this.showService.galleryChange.subscribe(val=>{
        this.showList=val;
      });

  }

  splitUrl(){
    console.log(location.pathname);
    let url=location.pathname.split('/');
    if(url.length===3){
      this.hideList();
      this.router.navigate(['/gallery/'+url[2]]);

    }
    
  }
  ngAfterViewChecked(){
    this.cdRef.detectChanges();
  }
  convertingUrl(id:string){
    for(let i=0;i<id.length;i++){
      id=id.replace(/[“’”'":;.,/!@#$%`]/g,'-');
    }
    if(id.includes('(')){
      for(let i=0;i<id.length;i++){
        id=id.replace('(','-');
      }
    }
    if(id.includes(')')){
      for(let i=0;i<id.length;i++){
        id=id.replace(')','-');
      }
    }
    if(id.includes(' ')){
      for(let i=0;i<id.length;i++){
        id=id.replace(' ','-');
      }
    }
    if(id.includes('.')){
      for(let i=0;i<id.length;i++){
        id=id.replace('.','-');
      }
    }
    if(id.includes('_')){
      for(let i=0;i<id.length;i++){
        id=id.replace('_','-');
      }
    }
    return id;
    
  }
  hideList(){
    this.showService.hide();
  }

  ngOnDestroy(){
    this.sub.forEach(s=>{
      s.unsubscribe();
    })
  }
}
